import { createMuiTheme } from "@material-ui/core";
import spacing from "@material-ui/core/styles/spacing";
// import mixins from "@material-ui/core/umd";

// Override MUI defaults
export default createMuiTheme({
  typography: {
    fontFamily: '"Montserrat", sans-serif',
    // fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500
  },
  palette: {
    primary: {
      // main: "#40c0ff",
      // main: "#ff7b00",
      main: "#19adff",
      contrastText: "#ffffff"
    }
  },
  miniBox: {
    paddingLeft: spacing.unit * 3,
    paddingRight: spacing.unit * 3,
    paddingTop: spacing.unit * 2,
    paddingBottom: spacing.unit * 2
  }
  // overrides: {
  //   MuiPaper: {
  //     root: {
  //       paddingLeft: spacing.unit * 3,
  //       paddingRight: spacing.unit * 3,
  //       paddingTop: spacing.unit * 2,
  //       paddingBottom: spacing.unit * 2
  //     }
  //   }
  // }
});



// WEBPACK FOOTER //
// ./src/theme/index.js